import type { PolicyResponse } from '@http/queries/useFetchPolicies';

export function getUnlicensedPolicyDomainIds(
  policy: Pick<PolicyResponse, 'domainScope' | 'auditEntryIds'>,
  organisationDomainIds: number[],
  licensedDomainIds: number[],
): number[] {
  const coveredDomainIds =
    policy.domainScope === 'all-domains'
      ? organisationDomainIds
      : policy.auditEntryIds;
  const licensed = new Set(licensedDomainIds);
  return coveredDomainIds.filter((id) => !licensed.has(id));
}
